import React, { useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import ButtonBS from '../../../components/common/ButtonBS'
import PageLayout from '../../../components/common/PageLayout/PageLayout4'
import { getDirectionFromList, reqUpgradePersona } from '../../../actions/viewActions'
import '../../../styles/MessageSent/MessageSent.css'
import { MessageSent as i18n } from '../../../middlewares/i18n';
import { push } from 'connected-react-router'

import { track } from '../../../helpers/analytics';

const MessageSent = () => {
  const _i18n = useSelector(state => state.i18n)

  const dispatch = useDispatch()
  const advance = useCallback(
    () => {
      track('Application Continue Clicked');
      let direction = dispatch(getDirectionFromList())
      dispatch(push(direction))
    }, [])

  const reqPersona = useCallback(
    () => {
      dispatch(reqUpgradePersona())
    }, [])

  useEffect(() => {
    reqPersona()
  }, [])

  return(
    <PageLayout
        title={i18n[_i18n.language.current].title}
        price
        big
    >
      <div className='mess-sent-container'>
        <div className='paper-plane-red mess-sent-plane' />
        <p>{i18n[_i18n.language.current].instructions}</p>
        <br />
        <br />
        <p>{i18n[_i18n.language.current].instructions2}</p>
        <ButtonBS
          className ='mess-sent-button'
          content={i18n[_i18n.language.current].continue}
          onClick={ advance }
        />
      </div>
    </PageLayout>
  )
}

export default MessageSent